'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _CheckboxConstants = require('./CheckboxConstants');

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var RADIO_REF = 'radio';

exports.default = _react2.default.createClass({
  displayName: 'UIRadioInput',

  propTypes: {
    alignment: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
    'aria-labelledby': _react.PropTypes.string,
    checked: _react.PropTypes.bool,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    color: _react.PropTypes.string,
    defaultChecked: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    id: _react.PropTypes.string,
    inline: _react.PropTypes.bool,
    labelClassName: _react.PropTypes.string,
    name: _react.PropTypes.string,
    onChange: _react.PropTypes.func,
    readOnly: _react.PropTypes.bool,
    size: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.SIZE_OPTIONS)),
    text: _react.PropTypes.node,
    value: _react.PropTypes.any
  },

  contextTypes: {
    fieldSize: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.SIZE_OPTIONS))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      alignment: 'start'
    };
  },
  getInitialState: function getInitialState() {
    return {
      size: 'default'
    };
  },
  getComputedSize: function getComputedSize() {
    var computedSize = this.props.size || this.context.fieldSize;
    return computedSize;
  },
  getText: function getText(_ref) {
    var children = _ref.children,
        text = _ref.text;

    if (children && text) {
      _devLogger2.default.warn({
        message: 'UIRadioInput: `children` or `text` should be specified, not both.',
        key: 'UIRadioInput: children and text given'
      });
    }
    return children || text;
  },
  getWrapperClassName: function getWrapperClassName(_ref2, _ref3) {
    var alignment = _ref2.alignment,
        className = _ref2.className,
        inline = _ref2.inline;
    var computedText = _ref3.computedText;

    return (0, _reactUtils.classNames)('private-radio', className, _CheckboxConstants.ALIGNMENT_CLASSES[alignment], _CheckboxConstants.SIZE_OPTIONS[this.getComputedSize()], {
      'private-checkbox': computedText,
      'private-checkbox--inline': inline,
      'private-checkbox--flush': !computedText
    });
  },
  getInputClassName: function getInputClassName() {
    return (0, _reactUtils.classNames)('sr-only', 'private-checkbox__input');
  },
  getTextLabelClassName: function getTextLabelClassName(_ref4) {
    var size = _ref4.size;

    return (0, _reactUtils.classNames)('private-checkbox__text', {
      'private-checkbox__text--small': size === 'small'
    });
  },
  handleChange: function handleChange(event) {
    var _props = this.props,
        disabled = _props.disabled,
        onChange = _props.onChange,
        readOnly = _props.readOnly;

    if (disabled || readOnly) {
      event.preventDefault();
      return;
    }
    (0, _Functions.callIfPossible)(onChange, event);
  },
  renderTextLabel: function renderTextLabel(_ref5, _ref6) {
    var size = _ref5.size;
    var computedText = _ref6.computedText;

    if (computedText) {
      return _react2.default.createElement(
        'span',
        { className: this.getTextLabelClassName({ size: size }) },
        computedText
      );
    }

    return null;
  },
  render: function render() {
    var _props2 = this.props,
        alignment = _props2.alignment,
        ariaLabelledBy = _props2['aria-labelledby'],
        checked = _props2.checked,
        children = _props2.children,
        className = _props2.className,
        color = _props2.color,
        defaultChecked = _props2.defaultChecked,
        disabled = _props2.disabled,
        id = _props2.id,
        inline = _props2.inline,
        labelClassName = _props2.labelClassName,
        name = _props2.name,
        __onChange = _props2.onChange,
        readOnly = _props2.readOnly,
        text = _props2.text,
        value = _props2.value,
        rest = _objectWithoutProperties(_props2, ['alignment', 'aria-labelledby', 'checked', 'children', 'className', 'color', 'defaultChecked', 'disabled', 'id', 'inline', 'labelClassName', 'name', 'onChange', 'readOnly', 'text', 'value']);

    var computedText = this.getText({ children: children, text: text });

    if (!name) {
      _devLogger2.default.warn({
        message: 'UIRadioInput: `name` must be specified.',
        key: 'UIRadioInput: no name'
      });
    }

    return _react2.default.createElement(
      'div',
      _extends({}, rest, {
        className: this.getWrapperClassName({ alignment: alignment, className: className, inline: inline, size: this.getComputedSize() }, { computedText: computedText })
      }),
      _react2.default.createElement(
        'label',
        {
          className: (0, _reactUtils.classNames)('private-checkbox__label', labelClassName)
        },
        _react2.default.createElement(
          'span',
          { className: 'private-checkbox__inner' },
          _react2.default.createElement('input', {
            'aria-labelledby': ariaLabelledBy,
            checked: checked,
            className: this.getInputClassName(),
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: id,
            name: name,
            onChange: this.handleChange,
            readOnly: readOnly,
            ref: RADIO_REF,
            type: 'radio',
            value: value
          }),
          _react2.default.createElement(
            'span',
            {
              className: 'private-checkbox__indicator private-radio__indicator',
              style: { color: color }
            },
            _react2.default.createElement(
              'span',
              { className: 'private-checkbox__icon private-checkbox__check private-radio__icon' },
              _react2.default.createElement('div', { className: 'private-radio__icon__inner' })
            )
          ),
          this.renderTextLabel({ size: this.getComputedSize() }, { computedText: computedText })
        )
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/input/UIRadioInput.js
// module id = 211
// module chunks = 0